var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { aliyunLog } from 'mutants-log';
import User from '../model/User';
import tools from '../util/tools';
import { stores } from 'mutants-microfx';
export default function serverLog(logstore, param) {
    var user = User.restore();
    if (!tools.isNull(user.userId)) {
        //如果缓存中有登录信息  将登录参数附加
        var orgList = user.orgList, channel = user.channel, usermsg = __rest(user, ["orgList", "channel"]);
        usermsg.channel = channel.targetURL;
        var concatParam = __assign(__assign(__assign({}, param), usermsg), stores.logStore.logParam.appParam);
        aliyunLog(logstore, concatParam);
    }
    else {
        aliyunLog(logstore, param);
    }
}

//# sourceMappingURL=ServerLog.js.map
